import CheckIcon from "@mui/icons-material/Check";
import { Button } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { PsLabel } from "../../../components";
import PsModalWindow from "../../../components/PsModalWindow";
import PsContext from "../../../context";
import { useDialog } from "../../../context/DialogContext";
import { _SAVE_MODULES } from "../../../models/modulesModel";
import { formToObject } from "../../../utils";

const AddModuleFormComponents = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const { openDialog } = useDialog();

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _SAVE_MODULES(formToObject(form)).then((res) => {
      if (res.status == "1") {
        form.reset();
        context.setAlertMsg(res.message || "Saved");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Save",
        });
      }
      setLoader(false);
    });
  };

  return (
    <>
      <Spin spinning={loader}>
        <Form
          method="post"
          noValidate
          validated={validated}
          onSubmit={handleFormSubmit}
        >
          <Row>
            <Col md={4}>
              <PsLabel text="Module Title" required />
            </Col>
            <Col md={8}>
              <Form.Control
                type="text"
                name="module_title"
                placeholder="Title"
                size="sm"
                className="fw-bold"
                autoFocus
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={4}>
              <PsLabel text="Module Name" required />
            </Col>
            <Col md={8}>
              <Form.Control
                type="text"
                name="module_name"
                placeholder="Underscore Values Only"
                size="sm"
                className="fw-bold"
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={4}>
              <PsLabel text="Module Description" required />
            </Col>
            <Col md={8}>
              <Form.Control
                as="textarea"
                rows="4"
                name="module_description"
                placeholder="Description"
                size="sm"
                className="fw-bold"
                autoComplete="off"
                required
              />
            </Col>
          </Row>
          <Row className="mt-2 border-bottom pb-1">
            <Col md={10}>
              <PsLabel text="Allow to Create Action" />
            </Col>
            <Col md={2}>
              <Form.Check type="checkbox" name="action_create" />
            </Col>
          </Row>
          <Row className="mt-2 border-bottom pb-1">
            <Col md={10}>
              <PsLabel text="Allow to List Action" />
            </Col>
            <Col md={2}>
              <Form.Check type="checkbox" name="action_list" />
            </Col>
          </Row>
          <Row className="mt-2 border-bottom pb-1">
            <Col md={10}>
              <PsLabel text="Allow to Update Action" />
            </Col>
            <Col md={2}>
              <Form.Check type="checkbox" name="action_update" />
            </Col>
          </Row>
          <Row className="mt-2 border-bottom pb-1">
            <Col md={10}>
              <PsLabel text="Allow to Delete Action" />
            </Col>
            <Col md={2}>
              <Form.Check type="checkbox" name="action_delete" />
            </Col>
          </Row>
          <Row className="mt-2 border-bottom pb-1">
            <Col md={10}>
              <PsLabel text="Allow to Print Action" />
            </Col>
            <Col md={2}>
              <Form.Check type="checkbox" name="action_print" />
            </Col>
          </Row>
          <Row className="mt-2 border-bottom pb-1">
            <Col md={10}>
              <PsLabel text="Allow to Export Action" />
            </Col>
            <Col md={2}>
              <Form.Check type="checkbox" name="action_export" />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12}>
              <div className="text-end">
                <a
                  href="javascript:;"
                  className="me-3 text-decoration-underline"
                  onClick={(e) => props.onHide && props.onHide()}
                >
                  Cancel
                </a>
                <Button
                  type="submit"
                  variant="contained"
                  startIcon={<CheckIcon />}
                  size="small"
                >
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};
const AddModuleForm = (props) => {
  return (
    <>
      <PsModalWindow size="md" title="Add Module" {...props}>
        {props.show && <AddModuleFormComponents {...props} />}
      </PsModalWindow>
    </>
  );
};
export default AddModuleForm;
